export default __webpack_public_path__ + "static/media/road-network.6392663d.svg";